// ===========================================
// SCHEMA: Prórroga Fiscal
// ===========================================
// Schema Zod para el formulario de crear/editar prórrogas fiscales

import { z } from 'zod'

export const prorrogaSchema = z.object({
  impuesto_id: z.string().min(1, 'Seleccione un impuesto'),
  periodo: z.string().min(1, 'El período es requerido'),
  terminacion_cuit: z.string().nullable().optional(),
  fecha_original: z.string().min(1, 'La fecha original es requerida'),
  fecha_nueva: z.string().min(1, 'La fecha nueva es requerida'),
  motivo: z.string().min(1, 'El motivo es requerido'),
  fuente: z.string().nullable().optional(),
  referencia: z.string().nullable().optional(),
})

export type ProrrogaFormValues = z.infer<typeof prorrogaSchema>
